var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71454 13.9688C2.29476 13.9688 1.93704 13.821 1.64138 13.5253C1.34571 13.2297 1.19788 12.8719 1.19788 12.4522V4.54783C1.19788 4.12805 1.34571 3.77032 1.64138 3.47466C1.93704 3.17899 2.29476 3.03116 2.71454 3.03116H10.6189C11.0387 3.03116 11.3964 3.17899 11.692 3.47466C11.9877 3.77032 12.1355 4.12805 12.1355 4.54783V7.49999L14.8022 4.83333V12.1667L12.1355 9.49999V12.4522C12.1355 12.8719 11.9877 13.2297 11.692 13.5253C11.3964 13.821 11.0387 13.9688 10.6189 13.9688H2.71454ZM2.71454 12.4522H10.6189V4.54783H2.71454V12.4522Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamOutlined);
export default __webpack_public_path__ + "static/media/VideoCamOutlined.cc166fbd8a0d01d690150681c2d5dc05.svg";
export { ForwardRef as ReactComponent };